<template>
    <div class="row">
        <div class="col-md-4 mt-4">
            <div class="card border-0">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Conditions</p>
                    </div>
                </div>
                <div class="row justify-content-center ">
                    <div class="col-md-12">
                        <ul class="list-group mb-3" v-if="cons.length>0">
                            <li :class="(c.prescriptions.length>0?'border-bottom-0 ':'')+'list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0'" v-for="c in cons">
                                <div class="row">
                                    <div class="col-md-9 sb-list-fitem-regular">
                                        {{ c.cnd_sr ? c.cnd_srname : c.condition_data.cdd_name }}
                                        <div class="small" v-if="c.cnd_name">({{ c.cnd_name }})</div>
                                    </div>
                                    <div class="col-md-3 text-right sb-list-sitem">
                                        <a href="#" class="text-danger" @click="deleteConById(c)">
                                            Remove
                                        </a>
                                    </div>
                                    <div v-if="true" class="col-md-2 text-right sb-list-sitem">
                                        <a href="#" class="color-sky-blue-3" @click="show(c)">
                                            Edit
                                        </a>
                                    </div>
                                </div>
                                <ul class="list-group">
                                    <li class="list-group-item border-top-0 border-left-0 border-right-0 pt-1 pb-1 sb-list-thitem-regular" v-for="p in c.prescriptions">
                                        {{ p.pre_sr ? p.pre_srname : p.prescription_data.prd_name }}
                                        ({{ p.pre_dosage }} {{ p.dosage.dos_type }})
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 mt-4">
            <div class="card border-0">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title"><span v-if="update">Edit </span><span v-else>New </span>Condition</p>
                    </div>
                </div>
                <div class="justify-content-center" v-if="update && con.id==''">
                    <div class="col-md-12 text-center pb-3">
                        <h5 class="mt-5 mb-5">SELECT CONDITION TO EDIT</h5>
                    </div>
                </div>
                <div v-else class="justify-content-center">
                    <div class="col-md-12">
                        <div id="con-form">
                            <div class="form-group">
                                <label class="mb-0">What is your new condition?</label>
                                <small class="form-text text-muted mb-2">Entering the first few letters of your new condition will display a suggestion.</small>
                                <multiselect
                                    v-model="con.cnd_cdd"
                                    track-by="cdd_id"
                                    label="cdd_name"
                                    placeholder="Type to search condition"
                                    :searchable="true"
                                    :allow-empty="false"
                                    :options="searchconditions"
                                    :limit="3"
                                    @search-change="asyncFindCondition"
                                    :taggable="true"
                                    @tag="addSrCon"
                                    tag-placeholder="Add new condition"
                                >
                                    <template slot="noOptions">Please type to search</template>
                                </multiselect>

                            </div>

                            <div class="form-group">
                                <label class="mb-0">Do you have a prescription?</label>
                                <small class="form-text text-muted mb-2">Entering the first few letters of your existing prescription(s) will display a suggestion from your list. Enter all that apply.</small>
                                <multiselect
                                    v-if="!fromRx"
                                    v-model="con.prescriptions"
                                    track-by="pre_id"
                                    :custom-label="customLabel"
                                    placeholder="Type to search prescription"
                                    :searchable="true"
                                    :allow-empty="true"
                                    :options="searchrxs"
                                    :multiple="true"
                                    @search-change="asyncFindRx"
                                    ref="multiselect"
                                    :taggable="true"
                                    @tag="addSrPre"
                                    tag-placeholder="Add new prescription"
                                >
                                    <template slot="noOptions">Please type to search</template>
                                </multiselect>

                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <!--                                 <a href="#" type="button" class="btn btn-primary btn-sb">I have another prescription</a>-->
                                </div>
                                <div class="col-md-8 text-right pt-2">
                                    <a
                                        href="#"
                                        @click.prevent="rxForm=!rxForm"
                                        v-if="!rxForm"
                                        class="color-sky-blue-3"
                                    >
                                        I don't see my prescription in the list
                                    </a>
                                </div>
                            </div>
                            <div id="rx-form" v-if="rxForm" class="row">
                                <div class="col-md-6 form-group">
                                    <label class="mb-0">New prescription</label>
                                    <small class="form-text text-muted mb-2">Type to search new prescription</small>
                                    <multiselect
                                        name="prd_name"
                                        v-model="rx.pre_prd"
                                        track-by="pre_id"
                                        label="prd_name"
                                        placeholder="Type to search prescription"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :options="searchprescriptions"
                                        @search-change="asyncFindRxAdd"
                                        :limit="3"
                                        :taggable="true"
                                        @tag="addSrPre"
                                        tag-placeholder="Add new prescription"
                                    >
                                        <template slot="noOptions">Please type to search</template>
                                    </multiselect>

                                </div>
                                <div class="col-md-2 form-group">
                                    <small class="form-text text-muted mb-2">&nbsp;</small>
                                    <label class="mb-0">Dosage</label>
                                    <input type="number" placeholder="Dosage" v-model="rx.pre_dosage" id="pre_dosage" name="pre_dosage" class="required form-control"/>
                                </div>
                                <div class="col-md-2 form-group">
                                    <small class="form-text text-muted mb-2">&nbsp;</small>
                                    <label for="pre_dosid" id="pre_dosid_description" class="mb-0">Units</label>
                                    <select name="pre_dosid"
                                        v-model="rx.pre_dosid"
                                        class="form-control required"
                                        title="Units"
                                        aria-label="Units"
                                        aria-describedby="pre_dosid_description"
                                        aria-required="true"
                                        >
                                        <option v-for="dosage in dosages" :value="dosage.dos_id">
                                            {{ dosage.dos_type }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-2 form-group text-center pt-3">
                                    <a href="#" class="text-danger" @click="rxFormCancel">Remove</a>
                                    <button type="button" class="btn btn-primary mt-3" @click="saveRx">Add</button>
                                </div>
                                <div class="form-group">
                                    <input type="hidden" name="pre_prdid">
                                </div>
                            </div>

                            <div class="form-group">
                                <input type="hidden" name="cnd_cddid">
                            </div>
                            <div class="form-group">
                                <div class="sb-list-fitem-regular">
                                    Note
                                </div>
                                <textarea type="text" placeholder="Note" v-model="con.cnd_name" id="cnd_name" name="cnd_name" class="required form-control"></textarea>
                            </div>
                        </div>
                        <div class="text-right mb-3">
                            <button v-if="!update" type="button" class="btn btn-success" @click="saveCon">Add to My Conditions</button>
                            <button v-if="update" type="button" class="btn btn-success" @click="updateCon">Update My Condition</button>
                            <br/>
                            <a href="/my-health" type="button" class="btn btn-outline-secondary mt-3">Cancel</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .multiselect__placeholder {
        color:#6C757D;
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 1.6;
    }
</style>

<script>
import MyHealthMixin from "../../mixins/app/MyHealthMixin.vue";

export default {
    props: ['conditions', 'methodtype', 'prescriptions', 'dosages'],
    mixins: [MyHealthMixin],
    mounted() {
        this.listCon();
        this.getRx();
        this.update = this.methodtype !== 'add';
        this.addScreenReaderLabelsToMultiSelects();
    },
    created: function () {
        bus.$on('updateConditions', this.listCon)
        bus.$on('addCon', this.addConFromRx)
    },
    data() {
        return {
            route: '/api/conditions',
            rxroute: '/api/prescriptions',
            update: false,
            fromRx: false,
            rxForm: false,
            searchconditions: [],
            searchrxs: [],
            con: {
                id: null,
                cnd_cdd: {cdd_id: null},
                cnd_cddid: null,
                cnd_name: '',
                cnd_srname: '',
                prescriptions: [],
            },
            cons: [],
            searchprescriptions: [],
            rx: {
                id: null,
                pre_prd: null,
                pre_prdid: null,
                pre_name: '',
                pre_srname: '',
                pre_dosage: '',
                pre_dosid: '',
                conditions: []
            },
        }
    },
    methods: {
        rxFormCancel() {
            this.rxForm = false;
            this.rx = {
                id: null,
                pre_prd: null,
                pre_prdid: null,
                pre_name: '',
                pre_srname: '',
                pre_dosage: '',
                pre_dosid: '',
                conditions: []
            }
        },
        saveRx() {
            this.$http.post(this.rxroute, {
                conditions: this.rx.conditions,
                pre_dosage: this.rx.pre_dosage,
                pre_dosid: this.rx.pre_dosid,
                pre_name: this.rx.pre_name,
                pre_prdid: this.rx.pre_prd.prd_id,
                pre_srname: this.rx.pre_srname
            })
                .then(function (response) {
                    this.rxForm = false;
                    var rx = this.rx
                    this.rx = {
                        id: null,
                        pre_prd: null,
                        pre_prdid: null,
                        pre_name: '',
                        pre_srname: '',
                        pre_dosage: '',
                        pre_dosid: '',
                        conditions: []
                    };
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Prescription was created!'
                    });
                    rx.pre_id = response.body
                    rx.prescription_data = rx.pre_prd;
                    this.con.prescriptions = [rx];
                    this.getRx();
                }, (response) => {
                    this._handleErrors(response.data, '#rx-form')
                })
        },
        asyncFindRxAdd(query) {
            this.searchprescriptions = query === '' ? [] : this.prescriptions
        },
        asyncFindRx(query) {
            this.searchrxs = query === '' ? [] : this.rxs
        },
        asyncFindCondition(query) {
            this.searchconditions = query === '' ? [] : this.conditions
        },
        getRx() {
            this.$http.get('/api/prescriptions')
                .then(function (response) {
                    this.rxs = response.data;
                }, (response) => {
                    log(response);
                })
        },
        addRx(tag) {
            bus.$emit('addRx', this.con);
        },
        addSrCon(tag) {
            this.con.cnd_srname = tag;
            this.con.cnd_cdd = {
                cdd_name: tag,
                cdd_id: 0
            };
        },
        addSrPre(tag) {
            this.rxForm=true;
            this.rx.pre_srname = tag;
            this.rx.pre_prd = {
                prd_name: tag,
                prd_id: 0
            };
        },
        customLabel(data) {
            return (data.pre_sr ? data.pre_srname : data.prescription_data.prd_name) || ''
        },
        addCon() {
            this.update = false
            this.con = {
                id: null,
                cnd_cddid: null,
                cnd_cdd: null,
                cnd_name: '',
                prescriptions: [],
            };
        },
        saveCon() {
            this._clearErrors()
            if (this.rxForm) {
                let error_message = 'Please finish adding the new prescription by tapping on &quot;add&quot; or click remove.';
                let data = {
                    'message': error_message,
                    'errors': {
                        'pre_dosid': [error_message]
                    }
                };
                this._handleErrors(data, '#rx-form');
                return false;
            }

            // null safe injections
            if (this.con.cnd_cdd == null) {
                this.con.cnd_cc = {cdd_id: null};
            }

            this.$http.post(this.route, {
                cnd_cddid: this.con.cnd_cdd.cdd_id,
                cnd_name: this.con.cnd_name,
                cnd_srname: this.con.cnd_srname,
                prescriptions: this.con.prescriptions,
            })
                .then(function (response) {
                    this.listCon();
                    if(response.bodyText=="1"){
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Condition was updated!'
                        });
                    }else{
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Condition was updated!'
                            // type: 'error',
                            // title: 'Success',
                            // text: response.bodyText
                        });
                    }
                    this.con = {
                        id: null,
                        cnd_cddid: null,
                        cnd_cdd: null,
                        cnd_name: '',
                        prescriptions: [],
                    };
                }, (response) => {
                    this._handleErrors(response.data, '#con-form')
                })
        },
        show(c) {
            this.update = true
            this.con = {
                id: c.cnd_id,
                cnd_cdd: {
                    cdd_id: c.cnd_sr ? 0 : c.condition_data.cdd_id,
                    cdd_name: c.cnd_sr ? c.cnd_srname : c.condition_data.cdd_name,
                },
                cnd_cddid: c.cnd_cddid,
                cnd_name: c.cnd_name,
                cnd_srname: c.cnd_srname,
                prescriptions: c.prescriptions
            };
        },
        updateCon() {
            this._clearErrors();
            // null safe injections
            if (this.con.cnd_cdd == null) {
                this.con.cnd_cc = {cdd_id: null};
            }

            this.$http.put(this.route, {
                cnd_id: this.con.id,
                cnd_cddid: this.con.cnd_cdd.cdd_id,
                cnd_name: this.con.cnd_name,
                cnd_srname: this.con.cnd_srname,
                prescriptions: this.con.prescriptions,
            })
                .then(function (response) {
                    this.listCon();
                    if(response.bodyText=="1"){
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Condition was updated!'
                        });
                    }else{
                        this.$notify({
                            type: 'error',
                            title: 'Success',
                            text: response.bodyText
                        });
                    }

                }, (response) => {
                    this._handleErrors(response.data, '#con-form')
                })
        },
        deleteConById(con) {
            if (!confirm('Do you really want to delete this condition?'))
                return

            this.$http.delete(this.route + '/' + con.cnd_id)
                .then(function (response) {
                    this.listCon();
                    if(response.bodyText=="1"){
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Condition was deleted!'
                        });
                    }else{
                        this.$notify({
                            type: 'error',
                            title: 'Success',
                            text: response.bodyText
                        });
                    }
                    this.showModal = false;
                }, (response) => {
                    this._handleErrors(response.data, '#con-form')
                })
        },
        _handleErrors: function (items, selector) {
            this._clearErrors()
            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        },
        _clearErrors: function () {
            $('.has-error').removeClass('has-error');
            $('.help-block').remove();
        },
        addScreenReaderLabelsToMultiSelects() {
            $('.multiselect__tags:first').attr('aria-label', 'Search For Condition');
            $('.multiselect__tags:eq(1)').attr('aria-label', 'Search For Prescription');
        }
    }

}
</script>
